import React from "react";
import no_data_found from "../../assets/images/imgNo-removebg-preview.png";
import { Button, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function RecordNotFound2(props) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        textAlign: "center",
        p: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          p: 3,
          borderRadius: 2,
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          className="no-data-image"
          src={no_data_found}
          alt="No Data Found"
          style={{
            width: "200px",
            height: "auto",
            marginBottom: "16px",
          }}
        />
        <Typography variant="h6" sx={{ mb: 3 }}>
          {props.title || "No records found"}
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{
            mt: 2,
            textTransform: "none",
            px: 4,
            py: 1,
          }}
        >
          Go Back
        </Button>
      </Box>
    </Box>
  );
}
